<template>
  <div class="i-team-multi-picker">
    <div class="field-label">
      {{ resolvedLabel }}
    </div>
    <multiselect
      ref="multi"
      v-model="selected"
      label="name"
      trackBy="teamId"
      :options="teams"
      :multiple="false"
      :placeholder="resolvedPlaceholder"
      @search-change="onSearch"
      @select="onSelect"
      @remove="onRemove"
      @open="onOpen"
      @keydown.native="onKeydown"
    >
      <template slot="option" slot-scope="{ option }">
        <div>{{ option.name }}</div>
        <div v-if="showInfo" class="i-user-picker-email">{{ option.email }}</div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {listTeams} from "@/services/api/app/office/recovery/team/team";
import {defaultPagination} from "@/services/pagination";

export default {
  name: 'ITeamPicker',
  components: {Multiselect},
  props: {
    value: {},
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    filter: {
      type: Object,
      default: {
        "statuses": [
          1, 2, 4
        ]
      }
    },
    isGroup: {
      type: [Boolean, null],
      default: undefined
    },
    showInfo: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    resolvedLabel() {
      return this.label || this.$t('common.teamsAndGroups');
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('common.searchForTeams');
    }
  },

  data() {
    return {
      selected: null,
      teams: []
    }
  },

  methods: {
    onSearch(searchTerm) {
      this.teams = [];
      this.loadTeams(searchTerm)
    },
    loadTeams(search = null) {
      const payload = {
        pagination: {
          ...defaultPagination(),
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: this.filter
      }


      if (this.isGroup !== undefined) {
        payload.isGroup = this.isGroup
      }
      listTeams(payload)
        .then(({result, pagination}) => {
          this.teams = result;
        })
    },
    onSelect(data) {
      this.$emit('input', data)
    },
    onRemove(data) {
      this.$emit('input', null)
    },
    onOpen() {
      this.$nextTick(this.scrollHighlightedIntoView);
    },
    onKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        this.$nextTick(this.scrollHighlightedIntoView);
      }
    },
    scrollHighlightedIntoView() {
      const multi = this.$refs.multi;
      if (!multi || !multi.$el) return;

      const wrapper = multi.$el.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;

      const highlighted = wrapper.querySelector('.multiselect__option--highlight');
      if (highlighted) {
        highlighted.scrollIntoView({block: 'nearest'});
      }
    },
  },

  created() {
    if (this.value?.status != 4) {
      this.selected = this.value;
    }

    this.loadTeams();
  },
}
</script>

<style lang="scss">
@import "ITeamPicker";
</style>
